import React, { useEffect, useRef, useState } from "react";
import {
  ORG_ID,
  GRID_DEFAULT_PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
  USER_ID,
} from "../../../../constant/constant";
import { TableLoader } from "../../../../library/common/Loader";
import NORow from "../../../../library/custom/noRow/noRow";
import { Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import DialogBox from "../../../../library/common/DialogBox";
import { useDebounce } from "../../../../utils/useDebounceSearch";
import { getPreviousRoute } from "../../../../utils/routeTracker";
import {
  SW_INSPECTION_DAILY_VIEW,
  SW_INSPECTION_VIEW,
} from "../../../../constant/routeContant";

const DailyReportListContainer = ({
  isLoading,
  swInspectionList,
  count,
  viewOnClick,
  onRowClick,
  handleDeleteOnClick,
  getSwInspectionListData,
  getSwInspectionLists,
  shouldRestoreState,
}) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(GRID_DEFAULT_PAGE_SIZE);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const isFirstRender = useRef(true);

  const deleteReport = (reportId) => {
    setOpenModal(true);
    setSelectedRow(reportId);
  };
  const deletehandle = () => {
    setOpenModal(false);
    handleDeleteOnClick(selectedRow);
  };
  useEffect(() => {
    if (
      shouldRestoreState &&
      getSwInspectionLists?.filterViewObj &&
      getSwInspectionLists?.filterViewObj?.isDailyReport === true
    ) {
      const f = getSwInspectionLists.filterViewObj;
      setSearch(f.search || "");
      const restoredPage = f.page ?? 1;
      setPage(restoredPage > 0 ? restoredPage - 1 : 0);
      setPageSize(f.pageSize || GRID_DEFAULT_PAGE_SIZE);
    } else if (shouldRestoreState === false) {
      setSearch("");
      setPage(0);
      setPageSize(GRID_DEFAULT_PAGE_SIZE);
    }
  }, [shouldRestoreState]);

  const handleautoSearch = (event) => {
    setSearch(event.target.value);
    setPage(0);
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    setPage(0);
    const data = {
      page: 1,
      search: search ?? "",
      inspectionTypeId: 0,
      projectId: 0,
      customerId: parseInt(ORG_ID()),
      statusId: 0,
      startDate: "",
      endDate: "",
      pageSize: newPazeSize,
      userId: parseInt(USER_ID()),
      isDailyReport: true,
      statusIds: 0,
    };
    getSwInspectionListData(data);
  };
  const handlePagignation = (newPage) => {
    setPage(newPage);
    const data = {
      page: newPage + 1,
      search: search ?? "",
      inspectionTypeId: 0,
      projectId: 0,
      customerId: parseInt(ORG_ID()),
      statusId: 0,
      startDate: "",
      endDate: "",
      pageSize: pageSize,
      userId: parseInt(USER_ID()),
      isDailyReport: true,
      statusIds: 0,
    };
    getSwInspectionListData(data);
  };

  const columns = [
    {
      field: "reportId",
      headerName: "Report ID",
      flex: 1,
    },
    {
      field: "projectNumber",
      headerName: "Project Number",
      flex: 1,
    },
    {
      field: "projectName",
      headerName: "Project",
      flex: 1,
    },
    {
      field: "customer",
      headerName: "Client",
      flex: 1,
    },
    {
      field: "dateScheduled",
      headerName: "Date Scheduled",
      flex: 1,
      hide: false,
    },
    {
      field: "inspectionType",
      headerName: "Inspection Type",
      flex: 1,
    },
    {
      field: "frequency",
      headerName: "Frequency",
      flex: 1,
    },
    {
      field: "icon",
      renderHeader: () => (
        <SettingTable
          noOfRecords={count ?? 0}
          numberOfItemsPerPage={10}
          incidentLists={swInspectionList ?? []}
          fileNameXL={"inspections"}
        />
      ),
      flex: 0.7,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            view
            viewOnClick={(row) => viewOnClick(row)}
            viewLabel={"View Report"}
            // deleted
            // deleteOnClick={(row) => deleteReport(row?.reportId)}
            // deleteLabel="Delete Report"
          />
        );
      },
    },
  ];

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setPage(0);
    const data = {
      search: debouncedSearch ?? "",
      inspectionTypeId: 0,
      projectId: 0,
      customerId: parseInt(ORG_ID()),
      statusId: 0,
      startDate: "",
      endDate: "",
      page: 1,
      pageSize: pageSize,
      userId: parseInt(USER_ID()),
      isDailyReport: true,
      statusIds: 0,
    };
    getSwInspectionListData(data);
  }, [debouncedSearch]);

  return (
    <>
      <section className="grid_main_sec">
        {openModal && (
          <DialogBox
            open={openModal}
            rows={[]}
            header={"Confirm Deletion"}
            deletehandle={deletehandle}
            handleCloseModal={() => setOpenModal(false)}
            content={"Are you sure you want to delete this Report?"}
            view
          />
        )}
        <div className="grid_main_header two_grid">
          <Grid container item md={12} xs={12} className="">
            <Grid container className="confBox">
              <Grid item md={8} xs={12}>
                <div className="confTitile">My Daily Reports</div>
              </Grid>
            </Grid>
          </Grid>
        </div>

        <div className="grid_main_body">
          <div className="filter_of_caselist">
            <div className="searchcaseid">
              <label htmlFor="search">
                <span>
                  <SearchIcon />
                </span>
                <div>
                  <input
                    id="search"
                    placeholder="Search"
                    type="text"
                    value={search}
                    className=""
                    onChange={handleautoSearch}
                    autoComplete="off"
                  />
                </div>
              </label>
            </div>
          </div>

          <div className="desc_box row_uniq">
            <div className="table_style_ui">
              <GridTable
                getRowId={(r) => r.reportId}
                rows={swInspectionList ?? []}
                rowCount={count ?? 0}
                columns={columns}
                checkboxSelection={false}
                loading={isLoading}
                page={page}
                pagination
                pageSize={pageSize}
                rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                onPageChange={handlePagignation}
                onPageSizeChange={handlePageSizeChange}
                backIconButtonProps={{ disabled: false }}
                disableSelectionOnClick
                components={{
                  LoadingOverlay: TableLoader,
                  NoRowsOverlay: NORow,
                }}
                onClick={(rows) => onRowClick(rows)}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DailyReportListContainer;
